import { Component, OnInit, Input, OnChanges, SimpleChanges, OnDestroy, DoCheck } from '@angular/core';
import * as $ from 'jquery';
import { DamageService } from '../../service/damage.service';
import { Report } from '../../model/report.model';
import { Settings } from '../../model/settings.model';
import { ParametersService } from '../../service/parameters.service';
import { Subscription } from 'rxjs';
import { ReportService } from '../../service/report.service';

@Component({
  selector: 'app-report-scrollspy',
  templateUrl: './report-scrollspy.component.html',
  styleUrls: ['./report-scrollspy.component.less']
})
export class ReportScrollspyComponent implements OnInit, OnChanges {
  @Input() activeSection: string;
  @Input() numberDamage: number;
  @Input() report: Report;
  settings: Settings;
  showSignatory: boolean = true;
  showVehicleDetails: boolean = true;
  showPreselection: boolean = true;
  subscription: Subscription;

  constructor(private readonly _damageService: DamageService,
    private readonly _reportService: ReportService,
    private readonly _parametersService: ParametersService
  ) {
    this.settings = this._parametersService.getAll();
  }

  ngOnInit() {


  }

  ngOnChanges(change: SimpleChanges) {
    if (this.report) {
      if (this.report.typeReport === 'simple')
        if (this.settings
          && this.settings.report
          && this.settings.report.simple
          && this.settings.report.simple.signatory !== undefined)
          this.showSignatory = this.settings.report.simple.signatory;
        else if (this.settings
          && this.settings.report
          && this.settings.report.state
          && this.settings.report.state.signatory !== undefined)
          this.showSignatory = this.settings.report.state.signatory;
        else
          this.showSignatory = true;

      if (this.report.typeReport === 'simple') {
        if (this.settings
          && this.settings.report
          && this.settings.report.simple
          && this.settings.report.simple.vehicleDetails !== undefined)
          this.showVehicleDetails = this.settings.report.simple.vehicleDetails;
        else if (this.settings
          && this.settings.report
          && this.settings.report.state
          && this.settings.report.state.vehicleDetails !== undefined)
          this.showVehicleDetails = this.settings.report.state.vehicleDetails;
        else
          this.showVehicleDetails = true;
      }

      if (this.report.typeReport === 'simple'
        && this.settings
        && this.settings.report
        && this.settings.report.simple
        && this.settings.report.simple.picturesPreSelected !== undefined)
        this.showPreselection = this.settings.report.simple.picturesPreSelected;
      else if (this.settings
        && this.settings.report
        && this.settings.report.state
        && this.settings.report.state.picturesPreSelected !== undefined)
        this.showPreselection = this.settings.report.state.picturesPreSelected;
      else
        this.showPreselection = true;

    }
  }




  scrollTo(section: string) {
    $(`#${section} > .section-scroll-anchor`).get(0).scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }


}



// WEBPACK FOOTER //
// ./src/app/element/report-scrollspy/report-scrollspy.component.ts